const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    searchText: "",
    projects: [],
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        filterBySearchText: (state, action) => {
            state.searchText = action.payload;
        },
        projectChanged: (state, action) => {
            const { project, changeType } = action.payload;
            if (changeType === 'added') {
                state.projects.push(project);
            } else if (changeType === 'removed') {
                state.projects = state.projects.filter((existingProject) => existingProject !== project)
            }
        }
    },
});

export default filterSlice.reducer;
export const { projectChanged, filterBySearchText } = filterSlice.actions;
